"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.upperCaseFirstLetter = exports.replaceSpaceWithDash = void 0;
var replaceSpaceWithDash = function (input) {
    return input ? input.replace(/\s/g, '-') : '';
};
exports.replaceSpaceWithDash = replaceSpaceWithDash;
var upperCaseFirstLetter = function (text) {
    if (!text)
        return '';
    return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
};
exports.upperCaseFirstLetter = upperCaseFirstLetter;
